import { render, staticRenderFns } from "./editReport.vue?vue&type=template&id=0c0528d8&scoped=true&"
import script from "./editReport.vue?vue&type=script&lang=js&"
export * from "./editReport.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaCreat.less?vue&type=style&index=0&id=0c0528d8&lang=less&scoped=true&"
import style1 from "./editReport.vue?vue&type=style&index=1&id=0c0528d8&lang=less&scoped=true&"
import style2 from "./editReport.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0528d8",
  null
  
)

component.options.__file = "editReport.vue"
export default component.exports